import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "inputCode", "errorCode", "inputName", "errorName" ]

    validateCode() {
        let value = this.inputCodeTarget.value

        // 1. Convertir a mayúsculas automáticamente
        value = value.toUpperCase()

        // 2. Filtrar caracteres: Solo permite A-Z, 0-9 y _
        const sanitizedValue = value.replace(/[^A-Z0-9_]/g, "")

        // 3. Si el valor cambió (porque hubo minúsculas o caracteres inválidos), actualizar el input
        if (this.inputCodeTarget.value !== sanitizedValue) {
            this.inputCodeTarget.value = sanitizedValue

            // Mostrar aviso visual si hay un error target
            if (this.hasErrorCodeTarget && value !== sanitizedValue) {
                this.errorCodeTarget.textContent = "Solo mayúsculas, números y _"
                setTimeout(() => { this.errorCodeTarget.textContent = "" }, 4000)
            }
        }
    }

    validateName() {
        let value = this.inputNameTarget.value

        const sanitizedValue = value.replace(/[^a-zA-Z0-9 ]/g, "")

        /* Si el valor cambió (porque hubo caracteres inválidos), actualizar el input */
        if (this.inputNameTarget.value !== sanitizedValue) {
            this.inputNameTarget.value = sanitizedValue

            if (this.hasErrorNameTarget && value !== sanitizedValue) {
                this.errorNameTarget.textContent = "Solo minúsculas, mayúsculas y números"
                setTimeout(() => { this.errorNameTarget.textContent = "" }, 4000)
            }
        }
    }
}

